// Maakt van een volledige URL een leesbaar domein, bijvoorbeeld
// "https://www.flow.frl/" wordt "flow.frl".
export function getDisplayDomain(url: string): string {
  return url
    .replace(/^https?:\/\//i, '')
    .replace(/^www\./i, '')
    .replace(/\/+$/, '')
}
